import './App.css';
import './styles/owner-glass-dashboard.css';
import './styles/sidebar-icon-rail.css';
import './styles/authenticated-flat.css';
import './styles/maritime-design-system.css';
import './styles/reference-interface-theme.css';
import './styles/marine-shell.css';
import Router from './Router';
import { useSessionIdle } from './hooks/useSessionIdle';
import { applyMaritimeTheme } from './components/common/MaritimeThemeControl';

const idleMs = Number(process.env.REACT_APP_SESSION_IDLE_MS || 30 * 60 * 1000);

function App() {
  applyMaritimeTheme(window.localStorage.getItem('elog-maritime-theme') || 'day');
  useSessionIdle(idleMs);
  return <Router />;
}

export default App;
